import { Link } from "react-router-dom";

export const Nav = () => (
  <header className="fixed top-0 inset-x-0 z-50 bg-[#FBF9F5]/85 backdrop-blur-md border-b border-[#E2DDD5]">
    <nav className="mx-auto max-w-[1440px] px-5 md:px-10 h-14 md:h-16 flex items-center justify-between">
      <Link
        to="/"
        data-testid="nav-wordmark"
        className="font-sans font-semibold tracking-[0.18em] text-[10px] sm:text-[11px] md:text-xs text-[#1A1918] hover:text-[#C85A32] transition-colors duration-300"
      >
        CHRISTOPHER COLLINS
      </Link>
      <div className="flex items-center gap-4 sm:gap-6 md:gap-9 font-sans tracking-[0.18em] text-[10px] sm:text-[11px] md:text-xs text-[#1A1918]">
        <Link to="/#work" data-testid="nav-link-work" className="link-sweep py-1">
          WORK
        </Link>
        <Link to="/about" data-testid="nav-link-about" className="link-sweep py-1">
          ABOUT
        </Link>
        <a
          href="/christopher-collins-resume.pdf"
          target="_blank"
          rel="noreferrer"
          data-testid="nav-link-resume"
          className="link-sweep py-1"
        >
          RESUME
        </a>
      </div>
    </nav>
  </header>
);
